import { Component, Input } from '@angular/core';
import { IPayer } from '../payer.model';
import { PayerMappingModule } from '../payer-mapping.module';
import { CarrierEntity } from 'src/app/Models/CarrierEntity';
import { CarrierWithPayerAndState } from 'src/app/Models/CarrierWithPayerAndState';

@Component({
    selector: 'app-payer-details',
    templateUrl: './payer-details.component.html',
    styleUrls: ['./payer-details.component.css'],
    standalone: false
})
export class PayerDetailsComponent {
  @Input() carrier!: CarrierWithPayerAndState;

  isMapped(entity: CarrierWithPayerAndState) {
    return entity.payerName === null ? 'False' : 'True';
  }
}
